import { Formik, useField } from "formik";
import AppInputField from "components/shared/FormComponents/AppInputField";
import Question from "components/shared/ReportComponents/Questions/Question";
import QuestionWithRadio from "components/shared/ReportComponents/Questions/QuestionWithRadio";
import QuestionWithDD from "components/shared/ReportComponents/Questions/QuestionWithDD";
import { ATTENDANCE_QUESTION_IDS, CONSULTATION_PLANT_REPORT_QUESTIONS, DISCHARGE_SUMMARY_REPORT_QUESTIONS, REPORT_QUESTIONS } from "config/constants";
import QuestionAutocomplete from "./QuestionAutocomplete";
import QuestionWithTemplate from "./QuestionWithTemplate";
import QuestionDate from "./QuestionDate";
import QuestionReferralReason from "./QuestionReferralReason";
import { memo, useMemo } from "react";
import QuestionTracker from "./QuestionTracker";
import QuestionCounter from "./QuestionCounter";
import QuestionAttendance from "./QuestionAttendance";

const RenderQuestion = memo(function RenderQuestion({ question, ...props }) {
  const [field, meta] = useField(props.fieldName);
  return (
    <>
      <div className="d-flex align-itmes-center gap-10 mb-2">
        {question?.visibility !== "default" && (
          <AppInputField
            name={`${question?.id}.other_details.visibility`}
            type="checkbox"
            className="form-check"
            style={{ height: 25, width: 25 }}
          />
        )}
        {props.showQuestion !== false && (
          <h6 className="m-0 fw-sbold themeBlue pb-1">{question?.question}</h6>
        )}
      </div>
      {question?.question_type === "textarea_ac" ? (
        <QuestionAutocomplete
          question={question}
          {...props}
          {...field}
        />
      ) : question?.question_type === "textarea" ? (
        question?.id === DISCHARGE_SUMMARY_REPORT_QUESTIONS.referral_reason ? (
          <QuestionReferralReason
            question={question}
            {...props}
            {...field}
          />
        ) : (
          <Question
            question={question}
            {...props}
            {...field}
          />
        )
      ) : question?.question_type === "textarea_radio" ? (
        <QuestionWithRadio question={question} {...props} {...field} />
      ) : question?.question_type === "textarea_dd" ? (
        <QuestionWithDD question={question} {...props} {...field} />
      ) : question?.question_type === "template" ? (
        <QuestionWithTemplate question={question} {...props} {...field} />
      ) : question?.question_type === "date" ? (
        <QuestionDate question={question} {...props} {...field} />
      ) : question?.question_type === "tracker" ? (
        <QuestionTracker question={question} {...props} {...field} />
      ) : question?.question_type === "counter" ? (
        <QuestionCounter question={question} {...props} {...field} />
      ) : ATTENDANCE_QUESTION_IDS.includes(question?.id) ? (
        <QuestionAttendance question={question} {...props} {...field} />
      ) : (<p>Unable to render question</p>)}
    </>
  );
});


export const RenderQuestionById = memo(function RenderQuestionById({ questionId, reportQuestions, ...props }) {
  const question = useMemo(() => {
    if (!questionId || !reportQuestions?.length) {
      return null;
    }

    return reportQuestions?.find((q) => q.id === questionId);
  }, []);
  if (!question) {
    return <p>Question not found!</p>;
  }

  return (
    <RenderQuestion
      question={question}
      fieldName={question?.id}
      {...props}
    />
  );
})

export default RenderQuestion;